"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _duration = _interopRequireDefault(require("./duration"));

const DurationTotal = ({
  duration
}) => /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
  className: "duration__separator"
}), /*#__PURE__*/_react.default.createElement(_duration.default, {
  duration: duration
}));

DurationTotal.propTypes = {
  duration: _propTypes.default.number
};
DurationTotal.defaultProps = {
  duration: undefined
};
var _default = DurationTotal;
exports.default = _default;